export default function Model() {
  const LoginMdl = () => ({
    email: "",
    password: "",
  });

  const ChgPassMdl = () => ({
    oldPass: "",
    password: "",
    confirmPass: "",
  });

  const CityMdl = () => ({
    id: 0,
    orgId: "",
    branchId: "",
    name: "",
  });

  const AttendanceMdl = () => ({
    id: 0,
    memberId: "",
    attendType: 2,
    date: new Date().toLocaleDateString(),
    inTime: new Date(),
    outTime: new Date(),
    addedUserId: "",
    orgId: "",
    branchId: "",
  });

  const MemberStatusMdl = () => ({
    id: 0,
    orgId: "",
    branchId: "",
    name: "",
  });
  const PaymentMdl = () => ({
    id: 0,
    memberId: "",
    invId: "",
    amt: "",
    method: "",
    refe: "",
    payDate: new Date().toLocaleDateString(),
    note: "",
    files: [],
    paymentFiles: [],
  });

  const InvoiceMdl = () => ({
    id: 0,
    memberId: "",
    pkgType: "",
    subsTypeId: "",
    subsPlanId: "",
    title: "",
    amount: "",
    discount: "",
    netPay: "",
    freeFreezeCount: "",
    duration: "",
    dueDate: "",
    startDate: "",
    endDate: "",
    userId: "",
  });

  const SubsTypeMdl = () => ({
    id: 0,
    name: "",
    userId: "",
  });

  const InqSrcMdl = () => ({
    id: 0,
    name: "",
  });

  const FollowUpTypeMdl = () => ({
    id: 0,
    name: "",
  });

  const SubsPlanMdl = () => ({
    id: 0,
    name: "",
    subsTypeId: "",
    duration: "",
    amt: "",
    freezeCount: "",
    userId: "",
  });

  const ForgotMdl = () => ({
    email: "",
    forgotStep: "",
    verCode: "",
    password: "",
    confirmPass: "",
  });

  const FollowUpMdl = () => ({
    id: 0,
    followUpDate: "",
    followUpTime: "",
    followUpTypeId: "",
    note: "",
  });

  const OrgMdl = () => ({
    id: "",
    name: "",
    nameLocale: "",
    email: "",
    phone: "",
    country: "",
    cityId: "",
    state: "",
    zip: "",
    address: "",
    userId: "",
  });

  const UserMdl = () => ({
    id: 0,
    role: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPass: "",

    gender: "",
    dob: "",
    phone: "",
    language: 1,
    cityId: "",
    state: "",
    country: "",
    address: "",
    zip: "",
    note: "",
    photo: "",
    photoFile: "",
    idProofs: [],
    idProofFiles: [],
  });

  const BranchMdl = () => ({
    id: 0,
    name: "",
    currency: "",
    country: "",
    phone: "",

    reezeFees: "",
    enrollmentFees: "",
    transferFees: "",
    email: "",
    website: "",
    machineIP: "",
    serverIP: "",
    taxNo: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    autoEmail: false,
    biometric: false,
    logo: "",
    logoFile: "",
  });

  const FreezeMdl = () => ({
    id: 0,
    memberId: "",
    invId: "",
    startDate: new Date().toLocaleDateString(),
    endDate: "",
    amount: "",
    waveAmt: false,
  });

  const MemberMdl = () => ({
    id: 0,
    memberId: "",
    enrollmentId: "",
    firstName: "",
    lastName: "",
    dob: "",
    cityId: "",
    gender: "",
    mobile: "",
    email: "",

    rfid: "",
    memberStatusId: "",
    remark: "",
    nationality: "",
    civilId: "",
    altMobile: "",
    address1: "",
    address2: "",
    photo: "",
    photoFile: "",
  });

  const MeasMdl = () => ({
    id: 0,
    date: new Date().toLocaleDateString(),
    memberId: "",
    height: "",
    weight: "",

    leanMuscle: "", //Percentage
    neck: "",
    lArm: "",
    rArm: "",
    navelPoint: "",
    lNavelPoint: "",
    thighL: "",
    thighR: "",
    shoulder: "",
    chest: "",
    upperAbs: "",
    upperWaist: "",
    lowerWaist: "",
    rCalves: "",
    lCalves: "",
    bmi: "",
    bmr: "",
    visceralFat: "",
    subcutaneousFat: "",
    healths: [],
    remarks: "",
  });

  const InquiryMdl = () => ({
    id: 0,
    firstName: "",
    lastName: "",
    gender: "",
    phone: "",
    inqSrcId: "",
    cityId: "",
    remark: "",

    email: "",
    address: "",
    subsTypeId: "",
    subsPlanId: "",
    inqDate: "",

    userId: "",
  });

  return {
    SubsPlanMdl,
    SubsTypeMdl,
    InquiryMdl,
    LoginMdl,
    ChgPassMdl,
    ForgotMdl,
    FollowUpMdl,
    MemberMdl,
    MeasMdl,
    FreezeMdl,
    BranchMdl,
    UserMdl,
    OrgMdl,
    InvoiceMdl,
    PaymentMdl,
    CityMdl,
    InqSrcMdl,
    FollowUpTypeMdl,
    MemberStatusMdl,
    AttendanceMdl,
  };
}
